import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { LoadingSection } from './LoadingSection';
import { AUD_INSIGHTS_GRID_COL_COUNT, INSIGHT_TITLES } from './constants';
import { InsightType } from '../domain';
import { useTranslation } from '../hooks';

type InsightsSectionProps = {
  type: InsightType;
  toolbar?: ReactNode;
  isLoading: boolean;
};

const ToolbarWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${({ theme }) => theme.spacing.values.threeQuarter};
  grid-column: 1 / span ${AUD_INSIGHTS_GRID_COL_COUNT};
  padding-bottom: ${({ theme }) => theme.spacing.values.base};

  & ~ & {
    padding-top: ${({ theme }) => theme.spacing.values.x3};
  }
`;

const SectionTitle = styled.div`
  ${({ theme }) => theme.styles.headings.heading4};
`;

export const InsightsSection: FC<React.PropsWithChildren<InsightsSectionProps>> = ({
  children,
  type,
  toolbar,
  isLoading,
}) => {
  const { t } = useTranslation();
  const title = t(INSIGHT_TITLES[type]);

  return (
    <>
      <ToolbarWrapper>
        <SectionTitle data-test={title}>{title}</SectionTitle>
        {toolbar}
      </ToolbarWrapper>
      {isLoading ? <LoadingSection type={type} /> : children}
    </>
  );
};
